const n = /* @__NO_SIDE_EFFECTS__ */ (e, o, t) => {
  const r = o - e;
  return r === 0 ? 1 : (t - e) / r;
};
export {
  n as progress
};
